import useTranslation from 'next-translate/useTranslation'
import { useEffect, useState } from 'react'

interface IProps {
  options: any
  label: string
  required?: any
  errors?: any
  isActive?: any
  readOnly?: boolean
  type?: string
}

const AppInput = ({
  options,
  label,
  required,
  errors,
  isActive,
  readOnly,
  type,
  ...rest
}: IProps) => {
  const { t, lang } = useTranslation('common')
  const [focused, setFocused] = useState(false)
  const [active, setActive] = useState(false)

  const handleTextChange = (e: any) => {
    e.target.value.length > 0 ? setActive(true) : setActive(false)
  }

  useEffect(() => {
    if (isActive) setActive(true)
  }, [])

  return (
    <div className='relative my-4'>
      <label
        className={`absolute left-4 font-normal text-gray-400 px-1 bg-white transition-all duration-150 pointer-events-none ${
          focused || active ? '-top-3 text-sm' : 'top-2.5 text-base'
        } `}
      >
        {label}
        {required && <em style={{ color: 'red' }}>*</em>}
      </label>
      <input
        readOnly={readOnly}
        onKeyUp={handleTextChange}
        className='rounded-md border border-gray-200 h-12 w-full focus:outline-primary px-5'
        {...options}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        type={type}
        {...rest}
      />
      {errors[options.name] && (
        <p className='text-sm font-normal' style={{ color: 'red' }}>
          {errors[options.name].message}
        </p>
      )}
    </div>
  )
}

export default AppInput
